import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardRoadStep = styled(Card)(({theme, active}) => ({
  borderRadius: '0.6em',
  alignSelf: 'center',
  width: '90%',
  backgroundColor: active === 'true' ? theme.cardRoadStep.backgroundActiveColor : theme.cardRoadStep.backgroundColor,
  padding: '0.8em'
}));